import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import React from "react";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  //   {
  //     key: "Pending verification",
  //     path: `${AUTH_PREFIX_PATH}${UNVERIFIED_ENTRY}`,
  //     component: React.lazy(() =>
  //       import("views/auth-views/authentication/pending-verification")
  //     ),
  //   },
];

export const protectedRoutes = [
  {
    key: "Home",
    path: `${APP_PREFIX_PATH}/home`,
    component: React.lazy(() => import("views/app-views/home")),
  },
  {
    key: "Dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/dashboard")),
  },
  {
    key: "user.manageAccount",
    path: `${APP_PREFIX_PATH}/account/*`,
    component: React.lazy(() => import("views/app-views/account")),
  },
  {
    key: "Schools",
    path: `${APP_PREFIX_PATH}/schools/`,
    component: React.lazy(() => import("views/app-views/schools")),
  },
  {
    key: "Rooms",
    path: `${APP_PREFIX_PATH}/rooms/`,
    component: React.lazy(() => import("views/app-views/rooms")),
  },
  {
    key: "Instructors",
    path: `${APP_PREFIX_PATH}/instructors/`,
    component: React.lazy(() => import("views/app-views/instructors")),
  },
  {
    key: "Instructors",
    path: `${APP_PREFIX_PATH}/instructors/:id`,
    component: React.lazy(() =>
      import("views/app-views/instructors/instructor-details")
    ),
  },
  {
    ket: "Students",
    path: `${APP_PREFIX_PATH}/students/`,
    component: React.lazy(() => import("views/app-views/students")),
  },
  {
    ket: "Student details",
    path: `${APP_PREFIX_PATH}/students/:id`,
    component: React.lazy(() =>
      import("views/app-views/students/student-details")
    ),
  },
  {
    key: "Support Courses",
    path: `${APP_PREFIX_PATH}/support-courses/`,
    component: React.lazy(() =>
      import("views/app-views/support-courses/index")
    ),
  },
  {
    key: "Support Course Details",
    path: `${APP_PREFIX_PATH}/support-courses/:id`,
    component: React.lazy(() =>
      import("views/app-views/support-courses/support-course-details")
    ),
  },
  {
    key: "Subjects",
    path: `${APP_PREFIX_PATH}/subjects/`,
    component: React.lazy(() => import("views/app-views/subjects")),
  },
  {
    key: "Trainings",
    path: `${APP_PREFIX_PATH}/trainings/`,
    component: React.lazy(() => import("views/app-views/trainings")),
  },
  {
    key: "Kids",
    path: `${APP_PREFIX_PATH}/trainings/kids`,
    component: React.lazy(() => import("views/app-views/trainings/kids")),
  },
  {
    key: "Trainings",
    path: `${APP_PREFIX_PATH}/trainings/new`,
    component: React.lazy(() => import("views/app-views/trainings/new")),
  },
  {
    key: "Trainings",
    path: `${APP_PREFIX_PATH}/trainings/edit/:id`,
    component: React.lazy(() => import("views/app-views/trainings/edit")),
  },
  {
    key: "Trainings details",
    path: `${APP_PREFIX_PATH}/trainings/:id`,
    component: React.lazy(() =>
      import("views/app-views/trainings/training-details")
    ),
  },
  {
    key: "Feedbacks",
    path: `${APP_PREFIX_PATH}/feedbacks`,
    component: React.lazy(() => import("views/app-views/feedbacks")),
  },
  {
    key: "Courses",
    path: `${APP_PREFIX_PATH}/courses/`,
    component: React.lazy(() => import("views/app-views/courses")),
  },
  {
    key: "Courses",
    path: `${APP_PREFIX_PATH}/courses/new`,
    component: React.lazy(() => import("views/app-views/courses/new")),
  },
  {
    key: "Courses",
    path: `${APP_PREFIX_PATH}/courses/edit/:id`,
    component: React.lazy(() => import("views/app-views/courses/edit")),
  },
  {
    key: "Courses",
    path: `${APP_PREFIX_PATH}/courses/:id`,
    component: React.lazy(() => import("views/app-views/courses/details")),
  },
  {
    key: "Groups",
    path: `${APP_PREFIX_PATH}/groups`,
    component: React.lazy(() => import("views/app-views/groups")),
  },
  {
    key: "Group Details",
    path: `${APP_PREFIX_PATH}/groups/:id`,
    component: React.lazy(() => import("views/app-views/groups/group-details")),
  },
  {
    key: "Internships",
    path: `${APP_PREFIX_PATH}/internships/`,
    component: React.lazy(() => import("views/app-views/internships")),
  },
  {
    key: "Internship Details",
    path: `${APP_PREFIX_PATH}/internships/:id`,
    component: React.lazy(() =>
      import("views/app-views/internships/internship-details")
    ),
  },
  {
    key: "Expenses",
    path: `${APP_PREFIX_PATH}/expenses/`,
    component: React.lazy(() => import("views/app-views/expenses")),
  },
  {
    key: "Calendars",
    path: `${APP_PREFIX_PATH}/calendars/`,
    component: React.lazy(() => import("views/app-views/calendars")),
  },
  {
    key: "Categories",
    path: `${APP_PREFIX_PATH}/categories/`,
    component: React.lazy(() => import("views/app-views/categories")),
  },
  {
    key: "quiz",
    path: `${APP_PREFIX_PATH}/quiz/`,
    component: React.lazy(() => import("views/app-views/quiz")),
  },
  {
    key: "quiz-new",
    path: `${APP_PREFIX_PATH}/quiz/new`,
    component: React.lazy(() => import("views/app-views/quiz/new")),
  },
  {
    key: "quiz-edit",
    path: `${APP_PREFIX_PATH}/quiz/edit/:id`,
    component: React.lazy(() => import("views/app-views/quiz/edit")),
  },
  {
    key: "quiz-participants",
    path: `${APP_PREFIX_PATH}/quiz-participants/`,
    component: React.lazy(() => import("views/app-views/quiz-participants")),
  },
  {
    key: "Certificates",
    path: `${APP_PREFIX_PATH}/certificates/`,
    component: React.lazy(() => import("views/app-views/certificates")),
  },
  {
    key: "Salaries",
    path: `${APP_PREFIX_PATH}/salaries/`,
    component: React.lazy(() => import("views/app-views/salaries")),
  },
  {
    key: "Salary Details",
    path: `${APP_PREFIX_PATH}/salaries/:id`,
    component: React.lazy(() =>
      import("views/app-views/salaries/salary-details")
    ),
  },
  {
    key: "Blogs",
    path: `${APP_PREFIX_PATH}/blogs`,
    component: React.lazy(() => import("views/app-views/events")),
  },
  {
    key: "Blogs Details",
    path: `${APP_PREFIX_PATH}/blogs/:id`,
    component: React.lazy(() => import("views/app-views/events/event-details")),
  },
  {
    key: "Registrations",
    path: `${APP_PREFIX_PATH}/registrations`,
    component: React.lazy(() => import("views/app-views/registrations")),
  },
  {
    key: "Registration History",
    path: `${APP_PREFIX_PATH}/registrations/history`,
    component: React.lazy(() =>
      import("views/app-views/registrations/history")
    ),
  },
  {
    key: "Subscriptions",
    path: `${APP_PREFIX_PATH}/subscriptions`,
    component: React.lazy(() => import("views/app-views/subscriptions")),
  },
  {
    key: "Tutorials",
    path: `${APP_PREFIX_PATH}/tutorials`,
    component: React.lazy(() => import("views/app-views/tutorials")),
  },
  {
    key: "Tutorials",
    path: `${APP_PREFIX_PATH}/tutorials/new`,
    component: React.lazy(() => import("views/app-views/tutorials/new")),
  },
  {
    key: "Tutorials",
    path: `${APP_PREFIX_PATH}/tutorials/edit/:id`,
    component: React.lazy(() => import("views/app-views/tutorials/edit")),
  },
  {
    key: "Tutorial Details",
    path: `${APP_PREFIX_PATH}/tutorials/:id`,
    component: React.lazy(() =>
      import("views/app-views/tutorials/tutorial-details")
    ),
  },
  {
    key: "Promotions",
    path: `${APP_PREFIX_PATH}/promotions`,
    component: React.lazy(() => import("views/app-views/promotions")),
  },
  {
    key: "Promotions",
    path: `${APP_PREFIX_PATH}/promotions/new`,
    component: React.lazy(() => import("views/app-views/promotions/components/new-promotion")),
  },
  {
    key: "Promotions",
    path: `${APP_PREFIX_PATH}/promotions/edit/:id`,
    component: React.lazy(() => import("views/app-views/promotions/components/edit-promotion")),
  },
  {
    key: "Promotion Details",
    path: `${APP_PREFIX_PATH}/promotions/:id`,
    component: React.lazy(() =>
      import("views/app-views/promotions/promotion-details")
    ),
  },
  {
    key: "Live Streams",
    path: `${APP_PREFIX_PATH}/live-streams`,
    component: React.lazy(() => import("views/app-views/live-streams")),
  },
  {
    key: "Admin Chat",
    path: `${APP_PREFIX_PATH}/communication/chat`,
    component: React.lazy(() => import("views/app-views/chat")),
  },
  {
    key: "BulkEmails",
    path: `${APP_PREFIX_PATH}/bulk-emails`,
    component: React.lazy(() => import("views/app-views/bulk-emails")),
  },
  {
    key: "BulkEmail Details",
    path: `${APP_PREFIX_PATH}/bulk-emails/:id`,
    component: React.lazy(() =>
      import("views/app-views/bulk-emails/bulk-email-details")
    ),
  },
  {
    key: "PlatformTutorial",
    path: `${APP_PREFIX_PATH}/platform-tutorials`,
    component: React.lazy(() => import("views/app-views/platform-tutorials")),
  },
  {
    key: "FidelityDashboard",
    path: `${APP_PREFIX_PATH}/fidelity/dashboard`,
    component: React.lazy(() => import("views/app-views/fidelity/dashboard")),
  },
  {
    key: "FidelityCards",
    path: `${APP_PREFIX_PATH}/fidelity/cards`,
    component: React.lazy(() => import("views/app-views/fidelity/cards")),
  },
  {
    key: "FidelityManagement",
    path: `${APP_PREFIX_PATH}/fidelity/manage`,
    component: React.lazy(() => import("views/app-views/fidelity")),
  },
  {
    key: "PrizesCatalogue",
    path: `${APP_PREFIX_PATH}/prizes/catalogue`,
    component: React.lazy(() => import("views/app-views/prizes/catalogue")),
  },
  {
    key: "PrizesRequests",
    path: `${APP_PREFIX_PATH}/prizes/requests`,
    component: React.lazy(() => import("views/app-views/prizes/requests")),
  },
];
